import ModelService from '../../base/ModelService';

class Project extends ModelService {
  constructor() {
    super('admin/projects');
  }
}

export default new Project();